import { useTranslation } from 'react-i18next';
import Box from '~/components/Box';
import FillBox from '~/components/FillBox.tsx';
import Typography from '~/components/Typography.tsx';
import { useState } from 'react';

export default function MessageBanner() {
  const [random] = useState<number>(Math.random());
  return random >= 0.5 ? <SuperFastDelivery /> : <AuthenticProducts />;
}

function SuperFastDelivery() {
  const { i18n } = useTranslation();
  return (
    <BackgroundBox backgroundImageUrl={'/superfast.png'}>
      <Box p={'16px'}>
        <Typography
          color={'white'}
          whiteSpace={'pre-wrap'}
          sx={{
            fontSize: '18px',
            fontWeight: '700',
            color: '#00FF11',
          }}
        >
          {i18n.t('message-banner-superfast-delivery')}
        </Typography>
        <Typography
          sx={{
            color: 'white',
          }}
        >
          {i18n.t('message-banner-orderby7-getitbefore11')}
        </Typography>
      </Box>
    </BackgroundBox>
  );
}

function AuthenticProducts() {
  const { i18n } = useTranslation();
  return (
    <BackgroundBox backgroundImageUrl={'/authentic.png'}>
      <Box p={'16px'}>
        <Typography
          color={'white'}
          whiteSpace={'pre-wrap'}
          sx={{
            fontSize: '18px',
            fontWeight: '700',
            color: '#FFEA00',
          }}
        >
          {i18n.t('message-banner-authentic-only')}
        </Typography>
        <Typography
          sx={{
            color: 'white',
          }}
        >
          {i18n.t('message-banner-not-genuine-pay-back-200%')}
        </Typography>
      </Box>
    </BackgroundBox>
  );
}

function BackgroundBox({
  children,
  backgroundImageUrl,
}: {
  children: React.ReactNode;
  backgroundImageUrl: string;
}) {
  return (
    <FillBox
      p={0}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '100%',
        height: '108px',
        background: `url("${backgroundImageUrl}")`,
        backgroundSize: 'contain',
        backgroundPosition: 'right',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#000',
      }}
    >
      {children}
    </FillBox>
  );
}
